export const iconFontAwesomeMapsHelicopter = (
	<i className="fa-solid fa-helicopter"></i>
);
